export const FLASH_SPY_UPSELL_SECONDS = 20;

export function flashSpyRemainingMs(expiresAtIso: string, now = Date.now()): number {
  const expires = Date.parse(expiresAtIso);
  if (!Number.isFinite(expires)) {
    return 0;
  }
  return Math.max(0, expires - now);
}

export function shouldShowFlashSpyUpsell(remainingMs: number): boolean {
  return remainingMs > 0 && remainingMs <= FLASH_SPY_UPSELL_SECONDS * 1000;
}

export function formatFlashSpyCountdown(remainingMs: number): string {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes)}:${String(seconds).padStart(2, '0')}`;
}
